import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import config from '../../../configs/config'
import { parseJsonResponse as parseApiJsonResponse } from '../../../shared/api/httpClient'

const apiUrl = config.apiurl

const buildQueryString = (payload) => {
  const params = new URLSearchParams()

  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    params.append(key, String(value))
  })

  return params.toString()
}

export const createMobileUser = createAsyncThunk(
  'agent/createMobileUser',
  async (payload, { rejectWithValue }) => {
    try {
      const query = buildQueryString(payload)
      const response = await fetch(`${apiUrl}CreateMobileUser?${query}`, {
        method: 'GET',
      })

      if (!response.ok) {
        throw new Error('Error al crear el agente')
      }

      const json = await parseApiJsonResponse(response)

      if (!json?.result) {
        throw new Error(
          json?.message ||
            json?.errorMessage ||
            'La API devolvio una respuesta invalida al crear el agente'
        )
      }

      return json
    } catch (error) {
      return rejectWithValue(error.message || 'No se pudo crear el agente')
    }
  }
)

const agentSlice = createSlice({
  name: 'agent',
  initialState: {
    creating: false,
    createError: null,
    createdUserResponse: null,
  },
  reducers: {
    clearCreateAgentState: (state) => {
      state.creating = false
      state.createError = null
      state.createdUserResponse = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createMobileUser.pending, (state) => {
        state.creating = true
        state.createError = null
      })
      .addCase(createMobileUser.fulfilled, (state, action) => {
        state.creating = false
        state.createError = null
        state.createdUserResponse = action.payload
      })
      .addCase(createMobileUser.rejected, (state, action) => {
        state.creating = false
        state.createError = action.payload || 'No se pudo crear el agente'
      })
  },
})

export const { clearCreateAgentState } = agentSlice.actions

export default agentSlice.reducer
